import {Component, OnInit} from '@angular/core';
import {User} from 'src/app/services/user/user';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
  UntypedFormControl,
  ReactiveFormsModule
} from '@angular/forms';
import {ColDef, ColGroupDef, GridApi, GridOptions} from 'ag-grid-community';
import {AppropriationChargeCodesService} from 'src/app/services/appropriation-charge-codes/appropriation-charge-codes.service';
import {PackageInformationService} from 'src/app/services/package-information/package-information.service';
import {AlertService} from 'src/app/services/alert/alert.service';
import {ButtonChargeCodeRendererComponent} from './ButtonChargeCodeRendererComponent';
import {BsDatepickerModule} from "ngx-bootstrap/datepicker";
import {TimepickerModule} from "ngx-bootstrap/timepicker";
import { DatePipe, NgClass } from "@angular/common";
import {TypeaheadModule} from "ngx-bootstrap/typeahead";
import {TabsModule} from "ngx-bootstrap/tabs";
import {AgGridAngular} from "ag-grid-angular";

@Component({
  standalone: true,
  imports: [
    ReactiveFormsModule,
    BsDatepickerModule,
    TimepickerModule,
    TypeaheadModule,
    TabsModule,
    AgGridAngular
],
  selector: 'app-frt-oto-app-charge-codes',
  templateUrl: './frt-oto-app-charge-codes.component.html',
  styleUrls: ['./frt-oto-app-charge-codes.component.css']
})
export class FrtOtoAppChargeCodesComponent implements OnInit {
  currentUser: User;
  appChargeCodeList: any = [];
  deletedChargeCodeList: any = [];
  frameworkComponents: any;
  shipmentPreferredAddressesGridOptions: GridOptions = this.initializeGridOptions();
  appChargeCodeForm: UntypedFormGroup;
  private gridApi!: GridApi<any>;

  constructor(public bsModalRef: BsModalRef,
              private fb: UntypedFormBuilder,
              public appropriationChargeCodesService: AppropriationChargeCodesService,
              private alertService: AlertService,
              public packageInformationService: PackageInformationService) {
    this.createFormControl();
    this.frameworkComponents = {
      buttonRenderer: ButtonChargeCodeRendererComponent,
    };
  }

  ngOnInit() {
    this.getAppropriationChargeCodesBasedOnOrganizationId();
  }

  createFormControl() {
    this.appChargeCodeForm = this.fb.group({
      chargeCode: new UntypedFormControl('', Validators.required),
      comments: new UntypedFormControl('', Validators.required)
    });
  }

  // get charge Codes based on organizationID
  getAppropriationChargeCodesBasedOnOrganizationId() {
    this.appropriationChargeCodesService.getAppropriationChargeCodesByOrganizationId(this.currentUser.organizationId).subscribe((data: any) => {
      this.appChargeCodeList = data;
      // this.packageInformationService.setChargeCodes(null);
      this.packageInformationService.setChargeCodes(this.appChargeCodeList);
      this.packageInformationService.getChargeCodes().subscribe((data2: any) => {
      });
    }, (error: any) => {
      this.alertService.error('There was an error retrieving charge code List');
    });
  }

  addToList() {
    this.appropriationChargeCodesService.saveAppropriationChargeCodes(this.buildPayload()).subscribe(
      (response: any) => {
        this.getAppropriationChargeCodesBasedOnOrganizationId();
      }, (error: any) => {
        console.log('having issue with creating a new Charge Code');
      });
  }

  private updateShipmentPreferredAddressRequest() {

  }

  buildPayload() {
    return {
      chargeCode: this.appChargeCodeForm.controls['chargeCode'].value,
      comments: this.appChargeCodeForm.controls['comments'].value,
      organizationId: this.currentUser.organizationId
    };
  }

  private getShipmentPreferredAddressColumnDefs(): (ColDef | ColGroupDef)[] {
    return [
      <ColDef>
        {
          headerName: 'charge Code',
          field: 'chargeCode'
        },
      {
        headerName: 'Comments',
        field: 'comments'
      },
      {
        headerName: 'Update Date',
        field: 'updateDate'
      },
      {
        headerName: 'updateId',
        field: 'updateId'
      },
      {
        headerName: 'Delete',
        cellRendererSelector: function (params) {
          const buttonRenderer = {
            component: 'buttonRenderer'
          };

          if (params.data == null) {
            return null;
          } else {
            return buttonRenderer;
          }
        },
        cellRendererParams: {
          onClick: this.onDeleteClick.bind(this),
          label: 'Delete'
        }
      }
    ];
  }

  onDeleteClick(e: any) {
    this.appropriationChargeCodesService.deleteAppropriationChargeCodes(e.rowData.appropriationChargeCodesId).subscribe((data) => {
      this.deletedChargeCodeList.push(e.rowData);
      this.appChargeCodeList.splice(this.appChargeCodeList.indexOf(e.rowData), 1);
      this.gridApi.setGridOption('rowData', this.appChargeCodeList);
      this.packageInformationService.setDeletedChargeCodes(this.deletedChargeCodeList);
      this.packageInformationService.getDeletedChargeCodes().subscribe((data2: any) => {
      });
    }, (error: any) => {
      console.log('there is an issue with deletion method');
    });

  }

  private initializeGridOptions() {
    return <GridOptions>{
      columnDefs: this.getShipmentPreferredAddressColumnDefs(),
      rowSelection: 'single',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      pagination: true,
      paginationPageSize: 10,
      cacheBlockSize: 10,
      domLayout: 'autoHeight',
      suppressDragLeaveHidesColumns: true,
      onGridReady: params => {
        params.api.sizeColumnsToFit();
        this.gridApi = params.api;
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
      overlayNoRowsTemplate:
        '<span>No results found. Please adjust your filters.</span>'
    };
  }
}
